import Portal from '../portal/portal';
import ButtonPrimary from '../button/button-primary';
import ButtonPseudo from '../button/button-pseudo';
import IconClose from '../icons/close';
import { PopupTypes } from './types';

import styles from './popup.module.css';

export default function Popup({
  title,
  description,
  onCancelClick,
  onOkClick,
  cancelButtonText,
  okButtonText,
  isVisible,
  warning,
  parent,
  children,
  popupClassName = '',
  isLoading,
  okButtonDisabled,
}: PopupTypes): React.JSX.Element {
  return (
    <div>
      {isVisible && (
        <Portal className={styles.popupPortal} parent={parent}>
          <>
            <button
              type="button"
              aria-label="Close popup"
              className={styles.popupOverlay}
              onClick={onCancelClick}
            />
            <div className={`${styles.popup} ${popupClassName}`}>
              <button
                type="button"
                className={styles.closePopupButton}
                aria-label="Close popup"
                onClick={onCancelClick}
              >
                <IconClose />
              </button>
              {title && <div className={styles.popupTitle}>{title}</div>}
              {description && (
                <div className={styles.popupDescription}>{description}</div>
              )}
              {children}
              {(okButtonText || cancelButtonText) && (
                <div className={styles.popupControls}>
                  {cancelButtonText && (
                    <ButtonPseudo
                      text={cancelButtonText}
                      onClick={onCancelClick}
                      bold
                    />
                  )}
                  {okButtonText && (
                    <ButtonPrimary
                      text={okButtonText}
                      onClick={onOkClick}
                      className={warning ? 'button-warning' : ''}
                      disabled={isLoading || okButtonDisabled}
                      bold
                    />
                  )}
                </div>
              )}
            </div>
          </>
        </Portal>
      )}
    </div>
  );
}
